import { Box, styled } from '@mui/joy';
import { SxProps } from '@mui/material';

import { Size } from 'theme/enums';

interface IProps {
  name?: string;
  label?: string;
  inline?: boolean;
  size?: Size;
  childSx?: SxProps;
  required?: boolean;
}

const propsToSkip = ['name', 'label', 'inline', 'size', 'childSx', 'required'];
const shouldForwardProp = (propName: string) => !propsToSkip.includes(propName);

const FormGroupWrapper = styled(Box, { shouldForwardProp })<IProps>({});

export default FormGroupWrapper;
